<template>
	<div>
	  <mu-appbar style="width: 100%;position:fixed" color="#2196f3" >  
			 <mu-button icon slot="left"  @click="goback">
               <mu-icon  value="arrow_back"></mu-icon>
         </mu-button>
         <mu-button icon slot="right"  >
           
         </mu-button>
			{{this.$route.params.title}}
      </mu-appbar>
      
      <mu-paper>
      	 <div style="height:80vh;padding-top:56px;" >
   
          <iframe :src="this.$route.params.url" style="width:100%;height:100vh"/>

      	 </div>
      </mu-paper>

    </div>

</template>
<script type="text/javascript">
  import Api from '@/api'
	export default {
     
     created(){
       this.refresh();
     },
		 data(){
           return {
         
          
           	datalist:[
           	 
            ],
           
          }
         },

        

         methods:{
        
          refresh()
          {
                Api.getNews().then((res)=>{
                 this.datalist=res.data;
                 
              })
          },
         	goback(){
         		this.$router.go(-1);
         	}
         }
	}
</script>
<style scoped>
  
 .mu-table  td {
    padding: 0;
    text-align: center;
    width:25%;
  }
  .mu-table th {
     padding: 0;
    text-align: center;
  }
  .expect_class {
      font-size:1rem;
      font-weight: bold;
  }
  .code_item {
     display: flex;
     justify-content: space-between;
    
     padding:10px;
  }
  .code_class {
     
      font-size:1rem;
      font-weight: bold;
    
  }
  .opencode_class {

     font-size:1rem;
      font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/pages/New.vue